import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { BREAKPOINTS } from '../BeFi20.meta';

export const Wrapper = styled(motion.div)({
  maxWidth: 640,
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 24,
  paddingBottom: 24,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    paddingTop: 40,
    paddingBottom: 40,
  },
});

export const Header = styled(Text).attrs({
  fontWeight: 600,
  textAlign: 'center',
  mt: '24',
})(({ theme }) => ({
  lineHeight: '40px',
  fontSize: theme.fontSizes.h2,
  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    fontSize: theme.fontSizes.h1,
    lineHeight: '48px',
  },
}));

export const LargeCopy = styled(Text).attrs({
  fontSize: 'h6',
  fontWeight: 500,
  color: 'neutral.600',
})``;
